"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpportunityCost = exports.getOpportunitySeats = exports.getUtilizationPercent = exports.getUtilizationRatio = exports.ratioToPercent = void 0;
function ratioToPercent(ratio, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 0; }
    return ratio ? "".concat((100 * ratio).toFixed(decimalPlaces), "%") : null;
}
exports.ratioToPercent = ratioToPercent;
function getUtilizationRatio(space, count, capacityField) {
    var capacityValue = space[capacityField];
    return capacityValue ? count / capacityValue : null;
}
exports.getUtilizationRatio = getUtilizationRatio;
function getUtilizationPercent(space, count, capacityField, decimalPlaces) {
    if (decimalPlaces === void 0) { decimalPlaces = 0; }
    var utilizationRatio = getUtilizationRatio(space, count, capacityField);
    return utilizationRatio !== null ? ratioToPercent(utilizationRatio, decimalPlaces) : null;
}
exports.getUtilizationPercent = getUtilizationPercent;
function getOpportunitySeats(space, count, capacityField) {
    var capacityValue = space[capacityField];
    return capacityValue ? capacityValue - count : null;
}
exports.getOpportunitySeats = getOpportunitySeats;
function getOpportunityCost(space, count, capacityField, costPerSeat) {
    var capacityValue = space[capacityField];
    return capacityValue ? (capacityValue - count) * costPerSeat : null;
}
exports.getOpportunityCost = getOpportunityCost;
//# sourceMappingURL=index.js.map